export default __webpack_public_path__ + "static/media/image_3.33da4ebb.jpg";